<template>
  <div class="game-container">
    <h1>记忆翻牌游戏喵！</h1>
    <div class="difficulty-select">
      <label>选择难度：</label>
      <select v-model="difficulty" @change="resetGame">
        <option value="4">简单（4×4）</option>
        <option value="6">中等（6×6）</option>
        <option value="8">困难（8×8）</option>
      </select>
    </div>

    <div class="cards" :class="`grid-${difficulty}`">
      <div
        v-for="(card, index) in cards"
        :key="index"
        class="card"
        :class="{
          flipped: card.isFlipped || card.isMatched,
          'no-transition': card.disableTransition,
        }"
        @click="flipCard(index)"
      >
        <div class="front">?</div>
        <div class="back">{{ card.value }}</div>
      </div>
    </div>

    <div class="game-info">
      <p>已匹配：{{ matchedPairs }} / {{ totalPairs }} 对喵</p>
      <button @click="resetGame">重新开始喵</button>
    </div>

    <!-- 自定义弹窗 -->
    <div v-if="showSuccessModal" class="success-modal">
      <div class="modal-content">
        <h2>🎉 恭喜喵！</h2>
        <p>你成功完成了所有配对！</p>
        <button @click="showSuccessModal = false">再玩一次</button>
      </div>
    </div>
  </div>
</template>

<script>
const EMOJI_POOL = [
  "🐱",
  "🐶",
  "🐰",
  "🐦",
  "🐠",
  "🐧",
  "🦊",
  "🐼",
  "🐨",
  "🦁",
  "🐮",
  "🐹",
  "🐻",
  "🐝",
  "🐞",
  "🦄",
  "🐢",
  "🐙",
  "🦋",
  "🐇",
  "🐿️",
  "🦀",
  "🐕",
  "🐈",
  "🦢",
  "🐘",
  "🐎",
  "🦜",
  "🦘",
  "🐂",
  "🐑",
  "🐩",
];

export default {
  name: "FlipCard",
  data() {
    return {
      difficulty: "4",
      cards: [],
      flippedIndices: [],
      matchedPairs: 0,
      showSuccessModal: false,
    };
  },
  computed: {
    totalPairs() {
      return parseInt(this.difficulty) ** 2 / 2;
    },
  },
  created() {
    this.resetGame();
  },
  methods: {
    resetGame() {
      const pairsNeeded = this.totalPairs;

      // 改进的表情选择逻辑
      const selectedEmojis = [];
      const availableEmojis = [...EMOJI_POOL];

      while (selectedEmojis.length < pairsNeeded) {
        if (availableEmojis.length === 0) {
          availableEmojis.push(...EMOJI_POOL);
        }
        const randomIndex = Math.floor(Math.random() * availableEmojis.length);
        selectedEmojis.push(availableEmojis.splice(randomIndex, 1)[0]);
      }

      // 创建卡片数组
      const values = [...selectedEmojis, ...selectedEmojis].sort(
        () => Math.random() - 0.5
      );

      // 验证卡片数量
      console.assert(
        values.length === parseInt(this.difficulty) ** 2,
        "卡片数量与难度不匹配"
      );

      this.cards = values.map((value) => ({
        value,
        isFlipped: false,
        isMatched: false,
        disableTransition: true,
      }));
      this.$nextTick(() => {
        setTimeout(() => {
          this.cards = this.cards.map((card) => ({
            ...card,
            disableTransition: false,
          }));
        }, 50);
      });
      this.flippedIndices = [];
      this.matchedPairs = 0;
      this.showSuccessModal = false;
    },
    flipCard(index) {
      if (
        this.flippedIndices.length === 2 ||
        this.cards[index].isFlipped ||
        this.cards[index].isMatched
      )
        return;

      this.cards[index].isFlipped = true;
      this.flippedIndices.push(index);

      if (this.flippedIndices.length === 2) {
        this.checkMatch();
      }
    },
    checkMatch() {
      const [index1, index2] = this.flippedIndices;
      const isMatch = this.cards[index1].value === this.cards[index2].value;

      if (isMatch) {
        this.cards[index1].isMatched = true;
        this.cards[index2].isMatched = true;
        this.matchedPairs++;

        if (this.matchedPairs === this.totalPairs) {
          this.showSuccessModal = true;
        }
      } else {
        setTimeout(() => {
          this.cards[index1].isFlipped = false;
          this.cards[index2].isFlipped = false;
        }, 800);
      }

      this.flippedIndices = [];
    },
  },
};
</script>

<style scoped>
.game-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.difficulty-select {
  margin: 20px 0;
}

.difficulty-select select {
  padding: 5px 10px;
  font-size: 16px;
}

.cards {
  display: grid;
  gap: 10px;
  justify-content: center;
  margin: 20px 0;
}

.grid-4 {
  grid-template-columns: repeat(4, minmax(70px, 1fr));
}
.grid-6 {
  grid-template-columns: repeat(6, minmax(45px, 1fr));
}
.grid-8 {
  grid-template-columns: repeat(8, minmax(30px, 1fr));
}

.card {
  aspect-ratio: 1;
  min-height: 30px;
  position: relative;
  cursor: pointer;
  transform-style: preserve-3d;
  transition: transform 0.5s;
}

.card.flipped {
  transform: rotateY(180deg);
}

.card.no-transition {
  transition: none !important;
}

.front,
.back {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5em;
  backface-visibility: hidden;
  border-radius: 8px;
}

.front {
  background: #ff9f43;
  color: white;
}

.back {
  background: #2e86de;
  color: white;
  transform: rotateY(180deg);
}

button {
  padding: 10px 20px;
  background: #ee5253;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s;
}

button:hover {
  background: #ff6b6b;
}

/* 成功弹窗样式 */
.success-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  padding: 30px;
  border-radius: 15px;
  text-align: center;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.modal-content h2 {
  color: #2ecc71;
  margin-bottom: 15px;
}

.game-info {
  margin-top: 20px;
}
</style>
